import * as React from 'react';

import {Carousel} from 'antd';

import {useHistory, useParams} from 'react-router-dom';

import LinkMore from '@app/components/LocalCommon/LinkMore/LinkMore';
import {months} from '@app/components/LocalCommon/Constants/Months';
import imagePlaceholder from '@app/images/image-placeholder.png';
import Chevron from '@app/images/chevron-pointing-to-the-left.svg';
import {bodyOverflowRemove, bodyOverflowTransform} from '@app/components/LocalCommon/Utils/bodyOverflowTransform';
import {getImagePath} from '@app/objects/Image';

export interface Date {
	month: string;
	day: number;
	year: number;
}

interface TesAuthorCreditsProps {
	firstName?: string;
	lastName?: string;
	city?: string;
	state?: string;
	date?: Date;
	isShowName?: boolean;
}

export const VetAvatar = ({vetAvatar, vetName}) => {
	return(
		<div className="vet-avatar">
			<img src={vetAvatar ? vetAvatar : imagePlaceholder} alt="vet"/>
			<span>{vetName}</span>
		</div>
	);
};

export const TesAuthorCredits: React.FC<TesAuthorCreditsProps> = ({firstName, lastName, city, state, date, isShowName = true}) => {
	return (
		<div className="tes-author-credits">
			<div className="tes-author-credits__personal">
				{isShowName && (firstName || lastName) &&
					<div className="tes-author-credits__name">
						<span>{firstName} </span>
						<span>{lastName}</span>
					</div>
				}
				{(city || state) &&
					<div className="tes-author-credits__location">
						<span>{city}</span>
						{(city && state) &&
							<span>, </span>
						}
						{state &&
							<span>{state}</span>
						}
					</div>
				}
			</div>

			<div className="tes-author-credits__date">
				{date && date.month &&
					<>
						<span>{date?.month} </span>
						<span>{date?.day}</span>
						<span>, </span>
						<span>{date?.year}</span>
					</>
				}
			</div>
		</div>
	);
};

const VetTesCard = ({ tes, navCollapse, setTesModalVisible}) => {
	const date = new Date(tes.dateCreated);
	const dateValues = {
		month: months[date.getMonth()],
		day: date.getDate(),
		year: date.getFullYear(),
	};

	const [imgSrc, setImgSrc] = React.useState(tes.avatar);

	const history = useHistory();
	const params: { id?: string | undefined } = useParams();

	const avatarHeight = 80;
	const avatarWidth = 80;
	const petImgHeight = 400;
	const petImgWidth = 280;
	React.useEffect(() => {
		setImgSrc(tes.avatar);
	}, []);

	const imageAltCapture = `
		Lap of Love Veterinary Hospice ${tes.city ? tes.city : ''}, 
		${tes.state ? tes.state : ''} Testimonial for Dr. ${tes.user.firstName} ${tes.user.lastName} 
		${tes.firstName ? `by ${tes.firstName} ${tes.lastName}` : ''}`;

	const openTestimonialCard = (e) => {
		bodyOverflowTransform(true);
		e.stopPropagation();
		e.preventDefault();
		setTesModalVisible(true);
		history.push(`/veterinarian-testimonials/${tes.id}`);
	};

	return (
		<div
			className = "vet-tes-card__wrapper"
			onClick={openTestimonialCard}
		>
			<div className = "vet-tes-card">
				<VetAvatar vetAvatar = {getImagePath(tes.user.avatar, avatarHeight, avatarWidth)} vetName = {`Dr. ${tes.user.firstName}`} />

				{
					!navCollapse ?
						<p className = "vet-tes-card__text">
							{tes.message}
						</p> :

						tes.avatar ?
							<div>
								<Carousel
									slidesToShow={1}
									dots={false}
									adaptiveHeight={true}
								>
									<div className="vet-tes-card_swipe">
										<p className = "vet-tes-card__text">
											{tes.message}
										</p>
									</div>

									<div className="vet-tes-card_swipe-img-wrapper">
										<img
											src={imgSrc !== imagePlaceholder ? getImagePath(imgSrc, petImgHeight, petImgWidth) : imgSrc}
											onError={() => setImgSrc(imagePlaceholder)}
											alt={imageAltCapture}
										/>
									</div>
								</Carousel>
							</div>
							:
							<p className = "vet-tes-card__text">
								{tes.message}
							</p>
				}

				<TesAuthorCredits
					firstName={tes.firstName}
					lastName={tes.lastName}
					city={tes.city}
					state={tes.state}
					date={dateValues} />
				<div className = "vet-tes-card__look-more">
					{tes.user.firstName &&
					<>
						{
							tes.user.areaUrl &&
							<LinkMore
								linkMoreCaption={`View Dr. ${tes.user.firstName}'s biography`}
								linkMoreLink={`/find-a-vet/${tes.user.area.state?.replace(' ', '-')}/${tes.user.areaUrl}/veterinarians?veterinarian=${tes.user.id}`}
							/>
						}

						{tes.petMemorial &&
							<LinkMore
								linkMoreCaption={`View ${tes.petMemorial.petName}'s memorial`}
								linkMoreLink={`/pet-memorial/${tes.petMemorial.id}`}/>
						}
					</>
					}
				</div>
				{navCollapse && tes.avatar &&
					<div className="vet-tes-card_swipe-pointer">
						<img src={Chevron} alt="Chevron"/>
					</div>
				}

			</div>
			{
				tes.avatar &&
				<div className = "vet-tes-card__pet-img">
					<img
						src={imgSrc !== imagePlaceholder ? getImagePath(imgSrc, petImgHeight, petImgWidth) : imgSrc}
						alt={imageAltCapture}
						onError={() => setImgSrc(imagePlaceholder)}
					/>
				</div>
			}
		</div>
	);
};

export default VetTesCard;